<template>
  <div
    class="login-container"
    :style="{
      backgroundImage: `url(${bgMain})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: 'white',
    }"
  >
    <!-- <img :src="birdLogo" class="birdLogo" alt="" /> -->

    <div class="maxxifiedLogoContainer">
      <img :src="maxxifiedLogo" class="newLogo" alt="" />
    </div>

    <p class="loginTitleNew">{{ $t('login.title') }}</p>
    <p class="loginSuitTitleNew">{{ $t('login.subtitle') }}</p>

    <div class="login-card">
      <form @submit.prevent="handleLogin" class="login-card-inner-section">
        <custom-input :label="$t('login.username')" type="text" :placeholder="$t('login.email_placeholder')" :value="username" @update:value="username = $event" :error="errors.username" />
        <div class="inputDiv">
          <div class="password-input-wrapper">
            <custom-input :label="$t('login.password')" :type="showPassword ? 'text' : 'password'" :placeholder="$t('login.password_placeholder')" :value="password" @update:value="password = $event" :error="errors.password" />
            <button type="button" class="password-toggle-btn" @click="togglePasswordVisibility">
              <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </button>
          </div>
        </div>

        <div class="buttonDiv">
          <custom-button :disabled="loading" @click="login">
            {{ $t('login.next') }}
            <div v-if="loading" class="spinner-border text-white spinner-grow-sm" role="status"></div>
          </custom-button>
        </div>
        <!-- <p class="forgotPasswordText">OR</p> -->
        <!-- In Login.vue -->
        <!-- <custom-button @click="$router.push('/register')">
          Go to Register
        </custom-button> -->

        <p class="forgotPasswordText" style="cursor: pointer" @click="goToForgotPassword">{{ $t('login.forgot_password') }}</p>
        <!-- <p class="termsAndConditions">
          {{ $t('login.analytics_info') }} <a class="highlightedText">{{ $t('login.cookie') }}</a> {{ $t('login.and') }}
          <a class="highlightedText">{{ $t('login.privacy_policy') }}</a>
        </p> -->
      </form>
    </div>

    <Footer />
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore'
import CustomInput from '../../components/CustomInput.vue'
import CustomButton from '../../components/CustomButton.vue'
import Footer from '../../components/Footer.vue'
import birdLogo from '@/assets/bird-logo.png'
import maxxifiedLogo from '@/assets/vasionLogin.png'
import bgMain from '@/assets/bg_main.png'

export default {
  data() {
    return {
      username: '',
      password: '',
      firstName: '',
      LastName: '',
      loading: false, // Added loading state
      showPassword: false, // Password visibility toggle
      message: this.$route.query.message || null,
      errors: {
        username: '',
        password: '',
      },
      birdLogo,
      maxxifiedLogo,
      bgMain,
    }
  },
  components: {
    CustomInput,
    CustomButton,
    Footer,
  },
  mounted() {
    document.title = 'Vasion IDP'
    localStorage.clear()
  },
  computed: {
    auth() {
      return useAuthStore()
    },
  },
  methods: {
    validateFields() {
      this.errors = { username: '', password: '' } // Reset errors

      if (!this.username) {
        this.errors.username = 'Please enter valid email address'
      }
      if (!this.password) {
        this.errors.password = 'Please enter valid Password'
      }

      return !this.errors.username && !this.errors.password // Return true if no errors
    },
    goToForgotPassword() {
      this.$router.push('/forgot-password')
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    updateValue(event) {
      this.$emit('update:value', event.target.value)
    },
    async handleLogin() {
      if (!this.validateFields()) return // Stop if validation fails
      this.loading = true
      // this.$router.push('/dashboard')

      const loginResponse = await this.auth.login(this.username, this.password)
      if (loginResponse?.data?.code === 200) {
        // Optionally check if OTP is required
        // clear store persist state here
        this.$router.push('/otp-verification')
      } else {
        // Optionally handle error (already set in this.auth.error)
        this.errors.username = 'Please enter valid email Id'
        this.errors.password = 'Incorrect password, Please enter a valid password'
        this.loading = false
      }
      // this.loading = false
      // // if (!this.auth.error && this.auth.AccessToken) {
      // this.$router.push('/otp-verification')
      // }
    },
  },
}
</script>

<style scoped>
@import '@/styles/login.css';

.password-input-wrapper {
  position: relative;
  width: 100%;
}

.password-input-wrapper :deep(.input-wrapper) {
  position: relative;
}

.password-input-wrapper :deep(.input-wrapper input) {
  padding-right: 45px;
}

.password-toggle-btn {
  position: absolute;
  right: 12px;
  top: calc(19.58px + 10px + 5px + 23px);
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667085;
  z-index: 10;
  transition: color 0.2s;
  height: 20px;
  width: 20px;
  margin-top: 0;
}

.password-toggle-btn:hover {
  color: var(--primary-color, #164863);
}

.password-toggle-btn:focus {
  outline: none;
}

.password-toggle-btn svg {
  width: 20px;
  height: 20px;
  stroke-width: 2;
}
</style>
